// extracted by mini-css-extract-plugin
export default {"wrapper":"loading_wrapper__2iva1","spinner":"loading_spinner__T5Vye","spin":"loading_spin__X9Z3Q","text":"loading_text__fuLu9"};